import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const EmailMigrationPage: React.FC = () => {
  return <ServicePageTemplate slug="email-migration" />;
};

export default EmailMigrationPage;
